import { useLazyQuery } from '@apollo/client/react';
import { useEffect, useState } from 'react';

import { GetPrescriptionFromNodeDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchAppointment = (appointmentId: string | null) => {
  const [error, setError] = useState<Error | null>(null);

  const [getAppointment, { called, loading, data, error: appointmentError }] = useLazyQuery(
    GetPrescriptionFromNodeDocument,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    },
  );

  const appointment = getNode(data, 'Appointment');

  useEffect(() => {
    if (appointmentError) {
      setError(appointmentError);
    }
  }, [appointmentError]);

  useEffect(() => {
    if (appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, getAppointment]);

  return { loading: !called || loading, error, appointment };
};
